import { useEffect, useState, useCallback } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const FALLBACK_HOURS = [
  { id: "fbh1", label_it: "Lun – Ven", label_en: "Mon – Fri", label_de: "Mo – Fr", time: "08:30 – 18:00", order: 1 },
  { id: "fbh2", label_it: "Sab", label_en: "Sat", label_de: "Sa", time: "08:30 – 17:00", order: 2 },
  { id: "fbh3", label_it: "Dom", label_en: "Sun", label_de: "So", time: "10:00 – 17:30", order: 3 },
];

export const useHours = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API}/settings/hours`);
      const apiRows = res.data?.rows;
      const data = Array.isArray(apiRows) ? apiRows : [];
      setRows(data.length > 0 ? data : FALLBACK_HOURS);
    } catch (e) {
      setRows(FALLBACK_HOURS);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { rows, loading, refresh };
};
